import { render, staticRenderFns } from "./fxjc.vue?vue&type=template&id=17966ea0&scoped=true&"
import script from "./fxjc.vue?vue&type=script&lang=js&"
export * from "./fxjc.vue?vue&type=script&lang=js&"
import style0 from "./fxjc.vue?vue&type=style&index=0&id=17966ea0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17966ea0",
  null
  
)

export default component.exports